import { AxiosError } from 'axios';
import { CreateStoreMenuRequest } from 'types/menu.type';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { menuService } from 'api/menu/menu.api.service';
import { parseAxiosError } from 'utils/errors';
import { DoorDashUpdateItemDto } from 'types/door-dash-update-item.dto';

export const getDoorDashStoreMenu = createAsyncThunk(
  'doordash/menu/getStoreMenu',
  async (storeNumber: string, { rejectWithValue }) => {
    try {
      const storeMenu = await menuService.getStoreMenu(storeNumber);
      return storeMenu;
    } catch (e) {
      const error = e as AxiosError;
      return rejectWithValue(parseAxiosError(error));
    }
  },
);

export const updateDoorDashStoreMenuItem = createAsyncThunk(
  'doordash/menu/stores/updateItem',
  async (menuParams: DoorDashUpdateItemDto[], { rejectWithValue }) => {
    try {
      const storeMenu = await menuService.updateMenuItem(menuParams);
      return storeMenu;
    } catch (e) {
      const error = e as AxiosError;
      return rejectWithValue(parseAxiosError(error));
    }
  },
);

export const updateDoorDashStoreMenu = createAsyncThunk(
  'doordash/menu/update',
  async (menuParams: CreateStoreMenuRequest, { rejectWithValue }) => {
    try {
      const storeMenu = await menuService.updateMenu(menuParams);
      return storeMenu;
    } catch (e) {
      const error = e as AxiosError;
      return rejectWithValue(parseAxiosError(error));
    }
  },
);

export const getDoorDashLastMenuUpdate = createAsyncThunk(
  'doordash/menu/getLastMenuUpdate',
  async (_, { rejectWithValue }) => {
    try {
      const lastUpdateTime = await menuService.getDoorDashLastMenuUpdate();
      return lastUpdateTime;
    } catch (e) {
      const error = e as AxiosError;
      return rejectWithValue(parseAxiosError(error));
    }
  },
);
